module.exports = __webpack_public_path__ + "static/media/ringback.6af5c7f2.wav";